<button
  class="btn btn-secondary--dark-blue d-flex align-items-center"
  (click)="onClick()"
  [attr.data-test]="'ummeldung-wizard-save-and-close-button'"
>
  <div class="mr-2">
    <img ngSrc="../assets/icon/icon-save-custom.svg" alt="Save Icon" width="24" height="24" />
  </div>
  @if (isLoading()) {
    <span class="loading-spinner"></span>
  } @else {
    <span>{{ 'ummeldung.button.saveAndClose' | translate }}</span>
  }
</button>
